module.exports = __webpack_public_path__ + "static/media/wiktoria.35c51a33.jpg";